import { render, staticRenderFns } from "./VolumeLibrary.vue?vue&type=template&id=5a2160c3&scoped=true&"
import script from "./VolumeLibrary.vue?vue&type=script&lang=js&"
export * from "./VolumeLibrary.vue?vue&type=script&lang=js&"
import style0 from "./VolumeLibrary.vue?vue&type=style&index=0&id=5a2160c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2160c3",
  null
  
)

export default component.exports